import { formatPostalAddress, type TrainingLocation } from "@shared-kernel/domain/types/postal-address";

interface TrainingLocationDisplayProps {
  address: TrainingLocation;
}

export const TrainingLocationDisplay = ({ address }: TrainingLocationDisplayProps) => {
  const formattedAddress = formatPostalAddress(address);

  return (
    <div className="text-sm">
      <span className="text-muted-foreground">Lieu de formation :</span> {formattedAddress}
      {address.addressComplement && <span className="text-muted-foreground"> — {address.addressComplement}</span>}
    </div>
  );
};
